import React, { createContext, useState, useEffect } from "react";

export const PartnerContext = createContext();

export const PartnerProvider = ({ children }) => {
    const [partner, setPartner] = useState(() => {
        return localStorage.getItem("partner") || null;
    });

    return (
        <PartnerContext.Provider value={{ partner, setPartner }}>
            {children}
        </PartnerContext.Provider>
    );
};
